import React from 'react';
import { TextField as MuiTextField } from '@mui/material';
import type { TextFieldProps } from '@mui/material';

type TimeFieldProps = TextFieldProps & {
  validateIsNotEmpty?: boolean | undefined;
  handleChange: (value: unknown) => void;
  handleBlur?: (value: unknown) => void;
};

function TimeField(props: TimeFieldProps) {
  const { validateIsNotEmpty = false, handleChange, handleBlur, ...rest } = props;

  return (
    <MuiTextField
      variant='standard'
      type='time'
      fullWidth
      required={validateIsNotEmpty || false}
      InputLabelProps={{
        shrink: true,
      }}
      onChange={(event) => handleChange(event.target.value)}
      inputProps={{
        onBlur: (event) => {
          if (handleBlur !== null && handleBlur !== undefined) {
            handleBlur(event.target.value);
          }
        },
      }}
      {...rest}
    />
  );
}

export type { TimeFieldProps };

export default TimeField;
